import useTransformedImageUrl from "@/shared/hooks/useTransformedImage";

interface ImageGridItemProps {
  mediaId: string;
  cloudfrontUrl: string;
  onClick: () => void;
}

const ImageGridItem = ({ cloudfrontUrl, onClick }: ImageGridItemProps) => {
  const { transformedImageUrl } = useTransformedImageUrl(cloudfrontUrl);

  return (
    <div
      className="bg-gray-100 bg-cover bg-center bg-no-repeat overflow-hidden h-[220px] lg:h-80 cursor-pointer"
      style={{
        backgroundImage: `url(${transformedImageUrl})`,
      }}
      onClick={onClick}
    />
  );
};

export default ImageGridItem;
